import MachineAddContainer from 'components/feature/machine/add/MachineAddContainer';

const MachineAddPage = () => {
  return <MachineAddContainer />;
};
export default MachineAddPage;
